<template>
  <div class="spinner">
    <div class="loader" id="widgetLoader"></div>
    <p v-if="message" class="spinnerMessage">{{ message }}</p>
  </div>
</template>

<script>
export default {
    name: "Spinner",
    props: {
      message: {
        type: String,
        required: false
      }
    }
}
</script>

<style scoped lang="scss">
  .spinner {
    text-align: center;
    width: 100%;
  }


/* LOADING SPINNER */
        .loader {
            border: 16px solid #f3f3f3; /* Light grey */
            border-top: 16px solid rgb(25, 115, 183) !important; 
            border-radius: 50%;
            width: 120px;
            height: 120px;

            margin: 0 auto;
            animation: spin 2s linear infinite;
        }
        /* Safari */
        @-webkit-keyframes spin {
          0% { -webkit-transform: rotate(0deg); }
          100% { -webkit-transform: rotate(360deg); }
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        .spinnerMessage {
          font-size: 20px;
          margin-top: 10px;
        }
</style>